<div class="normalScreen" style="background:white">
  <form [formGroup]="searchForm" (ngSubmit)="search()">
    <div style="margin-left:10px;margin-top:10px">
      <mat-form-field>
        <input matInput data-cy="dateHistory" [matDatepicker]="searchDate" [max]="maxDate" placeholder="Datum" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="searchDate"></mat-datepicker-toggle>
        <mat-datepicker #searchDate></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
      <button mat-flat-button color="primary" data-cy="searchHistory" type="submit" style="margin-left:10px;background:#7AB800" [disabled]="!canSearch()">Sök</button>
      <button mat-flat-button color="primary" data-cy="exportHistory" type="button" (click)="export()" [disabled]="!canExport()" style="margin-left:10px;background:#7AB800">Exportera till Excel</button>
    </div>
  </form>
  <div>
    <ngx-spinner #spinner [config]="spinnerConfig">
    </ngx-spinner>
    <div style="margin-left:10px;margin-top:10px" data-cy="alertNotFound" *ngIf="noMatch" class="alert alert-info">
      <label>Hittade ingen matchande data.</label>
    </div>
    <div height="700" style="position:relative">
      <div style="margin-top:15px">
        <canvas baseChart width="1100" height="500" data-cy="historyCharts"
                [datasets]="lineChartDataset"
                [labels]="lineChartLabels"
                [options]="lineChartOptions"
                [colors]="lineChartColors"
                [legend]="lineChartLegend"
                [chartType]="lineChartType"></canvas>
      </div>
    </div>
  </div>
</div>

